<template>
  <div :class="$style.page">
    <router-view />
    <Transition>
      <Loader v-if="loadersCount > 0" />
    </Transition>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader.vue";
import { mapState } from "vuex";

export default {
  components: {
    Loader,
  },
  computed: {
    ...mapState({
      loadersCount: (state) => state.loader.loadersCount,
      seconds: (state) => state.timer.seconds,
    }),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = `Mera ${to.meta.title || ""}`;
      },
    },
  },
};
</script>

<style lang="scss" module>
.page {
  min-height: 100vh;
  overflow: hidden;
}
</style>
